import React from 'react'
import styled from 'styled-components'
import { rem, transparentize } from 'polished'
import cn from 'clsx'

const Notice = styled.div`
  color: ${props => props.theme.palette.neutral.one};
  padding: ${rem(16)} ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.medium};

  &.warning {
    background: ${props => props.theme.palette.messaging.warning.light};
    border: 1px solid ${props => props.theme.palette.messaging.warning.main};
  }

  &.error {
    background: ${props => props.theme.palette.messaging.critical.light};
    border: 1px solid ${props => props.theme.palette.messaging.critical.main};
  }

  &.highlight {
    background: ${props => props.theme.palette.highlight.secondary.light};
  }

  &.success {
    background: ${props => transparentize(0.2, props.theme.palette.messaging.success.light)};
    border: 1px solid ${props => props.theme.palette.messaging.success.main};
  }

  & >:not(:first-child) {
    margin-top: ${rem(4)};
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  type: 'warning' | 'highlight' | 'error' | 'success';
}

function NoticeBox(props: Props) {
  const { className, type, ...rest } = props

  return <Notice {...rest} className={cn(className, type)} />
}

export default React.memo(NoticeBox)
